import { NAV_CHANGED } from "../types";

export default function nav(state = {}, action = {}) {
  switch (action.type) {
    case NAV_CHANGED: {
      return action.nav;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/nav.js